import { FunctionComponent, ReactNode } from 'react';
import { ResizeableStyles } from 'packages/at-shell/components/app-shell/styles/resizeable';
import { ThemeStyles } from 'packages/at-shell/components/app-shell/styles/theme';
import { PrimaryViewAreaStyles } from 'packages/at-shell/components/app-shell/styles/primary-view';
import { LayoutStyles } from 'packages/at-shell/components/app-shell/styles/layout';

export const Styles: FunctionComponent<
  React.PropsWithChildren<{
    colorTheme?: 'light' | 'dark';
    siderTitle?: string | ReactNode | false;
  }>
> = ({ colorTheme, siderTitle }) => {
  return (
    <>
      <ResizeableStyles />
      <ThemeStyles colorTheme={colorTheme} />
      <PrimaryViewAreaStyles />
      <LayoutStyles hasSiderHeader={siderTitle !== false} />
    </>
  );
};
